import React from 'react';
import { useTranslation } from 'react-i18next';
import './SoundToggle.css';

const SoundToggle = ({ enabled, onChange, variant = 'dark' }) => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      className={`sound-toggle ${enabled ? 'sound-toggle--on' : 'sound-toggle--off'} ${variant === 'light' ? 'sound-toggle--light' : ''}`}
      onClick={() => onChange(!enabled)}
      title={enabled ? t('kitchen.muteTitle') : t('kitchen.unmuteTitle')}
      aria-label={enabled ? t('kitchen.muteAria') : t('kitchen.unmuteAria')}
    >
      <span className="sound-toggle__icon" aria-hidden>
        {enabled ? '🔔' : '🔕'}
      </span>
      <span className="sound-toggle__label">{enabled ? t('kitchen.soundOn') : t('kitchen.soundOff')}</span>
    </button>
  );
};

export default SoundToggle;
